import cx from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { clickOutsideListener } from "../../../utils/clickOutsideListener";

// A dropdown filter component which can toggle multiple options to be on or off
export const DropDownFilterMinimal = (props) => {
    const [open, setOpen] = useState(false);
    const [listening, setListening] = useState(false);

    const disabled = props?.filterOptions?.disabled === true;
    const classNamePrefix = props?.filterOptions?.classNamePrefix || "minimal-indicator";
    const ref = useRef(null);

    useEffect(clickOutsideListener(listening, setListening, ref, setOpen));

    if (props?.filterOptions?.optionContextIdentifier) {
        // we should base our options based on a (context) passed element (ie: it could and should not be determined based on predefined information)

        // if nothing present, return empty element
        if (!props?.contextData?.[props.filterOptions.optionContextIdentifier]) {
            return <div className={"dropdown-filter-container"}></div>;
        }
    }

    const options = props?.filterOptions?.options || props?.contextData?.[props.filterOptions.optionContextIdentifier];

    return (
        <div className={cx(`${classNamePrefix}-filter-container`, "dropdown-filter-container")} ref={ref}>
            <div
                onClick={() => setOpen(!open)}
                className={cx("dropdown-filter-toggle", { "dropdown-filter-toggle--filter-active": props.state?.length > 0 && !disabled })}
            >
                <div className={"dropdown-filter-toggle__counter"}>{props?.state?.length || "0"}</div>
                <i className={cx("fa", { "fa-angle-down": !open, "fa-angle-up": open })} />
            </div>
            <div className={cx("dropdown-filter", { "dropdown-filter--open": open })}>
                {Object.entries(options).map((item, idx) => {
                    const [itemIdx, value] = item;

                    const key = value?.key || value?.slug || value?.id || "";

                    return (
                        <div key={idx} className={"dropdown-filter__input"}>
                            <input
                                id={key}
                                onChange={(e) => {
                                    let newOpts = e.target.checked
                                        ? !props.state?.includes(e.target.value)
                                            ? [...props.state, key]
                                            : [...props.state]
                                        : props.state.filter((o) => o !== key);
                                    props.setFilter(props.columnIdentifier, newOpts);
                                }}
                                checked={props.state?.includes(key) || false}
                                disabled={disabled}
                                value={key}
                                type={"checkbox"}
                                className={"dropdown-filter__checkbox"}
                            />
                            <label htmlFor={key} className={"dropdown-filter__label"}>
                                <span className={`${classNamePrefix} ${classNamePrefix}--${key}`}>{value.name}</span>
                            </label>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
